import React from "react";
import { Link } from "react-router-dom";
import { BrainCircuit, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { company } from "../mock";

const poweredBy = ["Addrish", "CRACS", "Ajubax AI", "The Lifespan Labs", "CogniSol"];

export default function Footer() {
  const cols = [
    { title: "Platform", items: [["Discover (Free)", "/discover"], ["Assessments", "/assessments"], ["Book Assessment", "/book"], ["For Schools", "/schools"], ["Insights", "/blog"], ["Business", "/partner"]] },
    { title: "Company", items: [["Mission & Vision", "/about"], ["Research", "/research"], ["Contact", "/contact"], ["Terms & Conditions", "/terms"], ["Refund Policy", "/refund-policy"], ["Privacy Policy", "/privacy-policy"]] },
  ];
  return (
    <footer className="relative overflow-hidden bg-[#120b26] text-slate-300">
      <div className="absolute inset-0 grain opacity-60" />
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-violet-600/20 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-fuchsia-500/20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="grid h-10 w-10 place-items-center rounded-xl cta-gradient text-white">
                <BrainCircuit className="h-6 w-6" />
              </span>
              <span className="text-[20px] font-extrabold text-white">MapMyKid</span>
            </Link>
            <p className="mt-4 text-[16px] leading-relaxed text-slate-400 max-w-xs">
              Discover and develop the true potential of your child. Advanced cognitive science assessments from Nursery to Grade 12.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-[16px] font-bold text-white">{c.title}</h4>
              <ul className="mt-4 space-y-3">
                {c.items.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="group inline-flex items-center gap-1 text-[16px] text-slate-400 hover:text-white transition-colors">
                      {label}
                      <ArrowUpRight className="h-4 w-4 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-[16px] font-bold text-white">Get in touch</h4>
            <ul className="mt-4 space-y-3.5">
              <li>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2.5 text-[16px] text-slate-400 hover:text-white transition-colors break-all">
                  <Mail className="h-4.5 w-4.5 text-violet-400 shrink-0" /> {company.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-[16px] text-slate-400">
                <MapPin className="h-4.5 w-4.5 text-violet-400 mt-0.5 shrink-0" /> India
              </li>
            </ul>
          </div>
        </div>

        {/* Collaborative platform note */}
        <div className="mt-12 rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-center">
          <p className="text-[13px] leading-relaxed text-slate-400 max-w-3xl mx-auto">
            MapMyKid is a collaborative platform built for the larger benefit of parents and schools worldwide. It is powered by a group of pioneering companies, {poweredBy.join(", ")}, that together provide the support, structure and invaluable systems behind every assessment.
          </p>
        </div>

        <div className="mt-8 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[15px] text-slate-500 text-center sm:text-left">
            &copy; {new Date().getFullYear()} MapMyKid. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-[15px] text-slate-500">Made with care for curious minds.</p>
            <Link to="/masteradmin" rel="nofollow" className="text-[13px] text-slate-600 hover:text-slate-400 transition-colors" data-testid="footer-master-login">Master Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
